import { render } from "./ProductList.vue?vue&type=template&id=5a94024a"
import script from "./ProductList.vue?vue&type=script&lang=js"
export * from "./ProductList.vue?vue&type=script&lang=js"

import "./ProductList.vue?vue&type=style&index=0&id=5a94024a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__